import axios from 'axios'
import Vue from 'vue'
import { logout } from '../services/authentication_service'
import { getLocalStorage, putLocalStorage } from '../helpers/LocalStorageHelper'
import { Authentication } from '../constants/DoITConstant'

const HEADER_BASE_AUTHENTICATION = process.env.VUE_APP_HEADER_BASE_AUTHENTICATION === 'TRUE'

const http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  transformRequest: [
    function (data, headers) {
      if (HEADER_BASE_AUTHENTICATION) {
        headers[Authentication.ACCESS_TOKEN_HEADER] = getLocalStorage(Authentication.ACCESS_TOKEN_KEY)
        headers[Authentication.REFRESH_TOKEN_HEADER] = getLocalStorage(Authentication.REFRESH_TOKEN_KEY)
      }

      return data
    },
  ],
})

http.interceptors.response.use(
  (response) => {
    if (HEADER_BASE_AUTHENTICATION && response.headers[Authentication.ACCESS_TOKEN_HEADER]) {
      putLocalStorage(Authentication.ACCESS_TOKEN_KEY, response.headers[Authentication.ACCESS_TOKEN_HEADER])
      putLocalStorage(Authentication.REFRESH_TOKEN_KEY, response.headers[Authentication.REFRESH_TOKEN_HEADER])
    }
    return response
  },
  (error) => {
    if ([401, 403].includes(error.response.status)) {
      logout()
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = http

export default http
